import React, { useContext, useMemo, useState } from 'react'
import { expirationTime1h, getCookie, saveCookie } from '@/resources/utils'
import { useSellerPermissions } from '@/proxy/seller/hooks'
import Loading from '@/components/generics/Loading'

export const ONLINE_PAYMENT_COOKIE = 'online_payment_enabled'

const OnlinePaymentContext = React.createContext()

export const OnlinePaymentProvider = props => {
  const [onLoad, setOnLoad] = useState(false)

  let skip = false

  if (getCookie(ONLINE_PAYMENT_COOKIE)) skip = true

  window.onload = () => {
    setOnLoad(true)
  }

  const {
    data: { seller = {} } = {},
    isLoading = false,
    isFetched = false,
    isError,
  } = useSellerPermissions({ skip }, { gcTime: 0 })

  const contextValue = useMemo(
    () => ({ onLoad, setOnLoad, isFetched, isError }),
    [onLoad, setOnLoad, isFetched, isError]
  )

  if (isLoading) return <Loading />

  const hasOnlinePaymentSection = seller?.permissions?.hasOnlinePaymentSection

  if (!skip && !isError && hasOnlinePaymentSection !== undefined) {
    const expiration6h = 6 * expirationTime1h

    saveCookie(
      ONLINE_PAYMENT_COOKIE,
      seller?.permissions?.hasOnlinePaymentSection ?? false,
      expiration6h
    )
  }

  return <OnlinePaymentContext.Provider value={contextValue} {...props} />
}

export const useOnlinePayment = () => {
  const context = useContext(OnlinePaymentContext)
  if (context === undefined) {
    throw new Error(
      'useOnlinePayment must be used within a OnlinePaymentContext'
    )
  }
  return context
}
